export default __webpack_public_path__ + "static/media/tunnel_psych.88825612.jpg";